export default __webpack_public_path__ + "static/media/a1-4-6.3484eebe.jpg";